import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useSourceFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    source: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ source }) => {
    setFilters(
      { source: source.value || 'any' },
      {
        removeFilters: source.value === 'any' ? ['source'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useSourceFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
